/* tslint:disable object-literal-sort-keys */
import React from 'react';

import { insertIf } from '@mighty-justice/utils';

import { IReactTableColumn, IReactTableItem } from '../../../interfaces';
import { FormattingUtils, TableRenderingUtils } from '../../../utils';

import ContactRowDropdown from './ContactRowDropdown';

const { renderPhoneNumber, renderUnformatted } = TableRenderingUtils
  , { getNameOrDefault } = FormattingUtils
  ;

export const TOOLTIP_LOAN_ACCOUNT_CONTACTS = 'tooltip-loan-account-contacts-table';

// Where the case contacts table links the name to the contact's own page. These contacts have none:
// they exist only on the accounts they are assigned to, and the row's Edit is how they are changed.
function renderName (item: IReactTableItem) {
  const name = getNameOrDefault(item.original);
  return <div className='contact-name ellipsis' data-for={TOOLTIP_LOAN_ACCOUNT_CONTACTS} data-tip={name}>{name}</div>;
}

interface IOptions {
  // Both Edit and Remove write to the contact, so one permission decides whether either is offered
  canChange: boolean;
  onEdit: (contactId: string) => void;
  onRemove: (contactId: string) => void;
}

/**
 * Built per set of handlers rather than declared as a constant, as the other lending tables' columns
 * are: the last column is the row's own actions.
 *
 * No Type column, unlike the case contacts table -- every contact here is an invoicing and payments
 * contact, and a column saying so on every row says nothing. The well's heading carries it instead.
 */
export function contactColumns ({ canChange, onEdit, onRemove }: IOptions): IReactTableColumn[] {
  const phoneProps = {
    Cell: renderPhoneNumber,
    className: 'col-style-gray',
    maxWidth: 120,
    minWidth: 50,
    tooltipId: TOOLTIP_LOAN_ACCOUNT_CONTACTS,
  };

  return [
    {
      accessor: 'first_name',
      Cell: renderName,
      Header: 'Name',
      maxWidth: 200,
      minWidth: 100,
    },
    {
      accessor: 'email',
      Cell: renderUnformatted,
      className: 'col-style-gray',
      Header: 'Email',
      minWidth: 100,
    },
    {
      accessor: 'phone_number',
      Header: 'Phone',
      ...phoneProps,
    },
    {
      accessor: 'additional_contact_info.cell_number',
      Header: 'Cell',
      ...phoneProps,
    },
    {
      accessor: 'additional_contact_info.fax_number',
      Header: 'Fax',
      ...phoneProps,
    },
    // Left off entirely rather than rendered empty for a user who cannot write to a contact: both of
    // the menu's items do, so there would be nothing behind the button.
    ...insertIf(canChange, {
      accessor: 'id',
      Cell: (item: IReactTableItem) => (
        <ContactRowDropdown contactId={item.value} onEdit={onEdit} onRemove={onRemove} />
      ),
      className: 'col-buttons',
      width: 40,
    }),
  ];
}
